import React, { Component } from 'react';
import {
  Input,
  InputGroup,
  InputGroupText,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from 'reactstrap';
import { connect } from 'react-redux';

class OperationMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allOperations: [],
      filteredOperations: [],
      selectedOperations: props.selectedOperations || [],
      searchTerm: '',
      isOpen: false,
    };
  }

  componentDidMount() {
    this.updateOperations();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedOperations !== this.props.selectedOperations) {
      this.setState({ selectedOperations: this.props.selectedOperations || [] });
    }
    // Update operations when storeIntegration changes
    if (prevProps.storeIntegration !== this.props.storeIntegration) {
      this.updateOperations();
    }
  }

  updateOperations = () => {
    const { storeIntegration } = this.props;

    let allOperations = [];
    if (storeIntegration && storeIntegration.operations) {
      allOperations = Object.keys(storeIntegration.operations);
    }

    // Remove duplicates and sort
    const uniqueOperations = [...new Set(allOperations)].sort();

    this.setState({
      allOperations: uniqueOperations,
      filteredOperations: uniqueOperations,
    });
  };

  handleSearchChange = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const filteredOperations = this.state.allOperations.filter((op) => op.toLowerCase().includes(searchTerm));

    this.setState({
      searchTerm: e.target.value,
      filteredOperations,
    });
  };

  toggleDropdown = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleOperationToggle = (operation) => {
    const { selectedOperations } = this.state;
    const newSelectedOperations = selectedOperations.includes(operation)
      ? selectedOperations.filter((op) => op !== operation)
      : [...selectedOperations, operation];

    this.setState({ selectedOperations: newSelectedOperations });
    this.props.onOperationChange(newSelectedOperations);
  };

  removeOperation = (operation) => {
    const { selectedOperations } = this.state;
    const newSelectedOperations = selectedOperations.filter((op) => op !== operation);
    this.setState({ selectedOperations: newSelectedOperations });
    this.props.onOperationChange(newSelectedOperations);
  };

  render() {
    const { allOperations, filteredOperations, selectedOperations, searchTerm, isOpen } = this.state;
    const { storeIntegration } = this.props;

    return (
      <div>
        {/* Search Dropdown */}
        <Dropdown isOpen={isOpen} toggle={this.toggleDropdown}>
          <DropdownToggle caret color="outline-secondary" className="w-100 text-left">
            {storeIntegration
              ? `${selectedOperations.length > 0 ? `${selectedOperations.length} selected` : 'Select Operations'} (${
                  allOperations.length
                } available)`
              : 'Select an integration first'}
          </DropdownToggle>
          <DropdownMenu left="true" style={{ minWidth: '350px', maxHeight: '400px', overflowY: 'auto' }}>
            {!storeIntegration ? (
              <DropdownItem disabled>Please select an integration first</DropdownItem>
            ) : (
              <>
                {/* Selected Operations Section */}
                {selectedOperations.length > 0 && (
                  <>
                    <div className="px-3 py-2 bg-light border-bottom">
                      <small className="text-muted fw-bold">Selected Operations ({selectedOperations.length})</small>
                    </div>
                    <div className="px-3 py-2">
                      {selectedOperations.map((operation) => (
                        <Badge key={operation} color="primary" className="me-1 mb-1">
                          {operation}
                          <Button
                            color="link"
                            size="sm"
                            className="p-0 ms-1 text-white"
                            onClick={() => this.removeOperation(operation)}
                          >
                            ×
                          </Button>
                        </Badge>
                      ))}
                    </div>
                    <DropdownItem divider />
                  </>
                )}

                {/* Search Section */}
                <div className="p-2">
                  <Input
                    type="text"
                    placeholder="Type to search operations..."
                    value={searchTerm}
                    onChange={this.handleSearchChange}
                    onClick={(e) => e.stopPropagation()}
                    className="form-control form-control-sm"
                  />
                </div>
                <DropdownItem divider />

                {filteredOperations.length === 0 ? (
                  <DropdownItem disabled>No operations found</DropdownItem>
                ) : (
                  filteredOperations.map((operation) => (
                    <DropdownItem
                      key={operation}
                      onClick={() => this.handleOperationToggle(operation)}
                      active={selectedOperations.includes(operation)}
                    >
                      {operation}
                    </DropdownItem>
                  ))
                )}
              </>
            )}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

export default connect((state) => ({
  storeIntegration: state.gateway.storeIntegration,
}))(OperationMultiSelect);
